import { useCallback, useEffect } from 'react';
import { addToast } from '@heroui/react';
import {
  handleNotificationNew,
  NOTIFICATION_SOCKET_EVENT,
  resolveNotificationSocketPayload,
  type NotificationSocketNewPayload,
} from '@/entities/MyNotifications';
import { useAppDispatch } from '@/shared/lib/hooks/useAppDispatch';
import { getChatSocketClient } from './getChatSocketClient';

// Вызывается один раз, из MainLayout. Подписка нужна на всех экранах, иначе уведомление
// приходит только когда открыт их список; а два вызова дали бы два тоста на одно событие.
export function useNotificationsRealtime() {
  const dispatch = useAppDispatch();

  const subscribeNotifications = useCallback(async (reason: string) => {
    try {
      await getChatSocketClient().subscribeNotifications();
    } catch (error) {
      console.error('[NotificationsSocket] notifications:subscribe failed', { reason }, error);
    }
  }, []);

  useEffect(() => {
    let client: ReturnType<typeof getChatSocketClient>;

    try {
      client = getChatSocketClient();
      client.connect();
    } catch (error) {
      console.error('[NotificationsSocket] connect failed', error);
      return;
    }

    void subscribeNotifications('layout mount');

    const offNew = client.onNotificationEvent(NOTIFICATION_SOCKET_EVENT.New, (data) => {
      handleNotificationNew(dispatch);

      const payload = resolveNotificationSocketPayload<NotificationSocketNewPayload>(data);
      if (payload?.title) {
        addToast({ title: payload.title, description: payload.message });
      }
    });

    const offReconnect = client.onConnect(() => {
      void subscribeNotifications('socket reconnect');
    });

    return () => {
      offNew();
      offReconnect();
    };
  }, [dispatch, subscribeNotifications]);
}
